module.exports = __webpack_public_path__ + "img/file.a2bfde42.svg";